import { isTelegramMiniApp, isMobileDevice } from "./telegram";
import { isMaxMiniApp } from "./max";
/** Ширина окна, ниже которой десктопный шелл заменяется мини-ап-версией. */
export const MINIAPP_SHELL_MAX_WIDTH = 770;
/**
 * ЕДИНСТВЕННЫЙ предикат выбора шелла приложения: TG/MAX-миниап, мобильный
 * браузер или узкое окно → мини-ап-шелл (`MiniAppContent`), иначе веб-шелл
 * (`Content`).
 *
 * Живёт здесь, а не в App.tsx, потому что тот же вопрос («какой роутер сейчас
 * активен») задаёт валидатор маршрутов уведомлений (`notification-center/model/
 * appRoutes`). Пока это выражение было продублировано в двух местах, наборы
 * роутов и шелл могли разъехаться — например, при смене порога ширины
 * валидация отваливалась бы только у десктопных пользователей с узким окном.
 *
 * `windowWidth` передаётся явно там, где ширина уже реактивна (App.tsx хранит её
 * в state и перечитывает по `resize`); без аргумента читаем `window.innerWidth`
 * на КАЖДЫЙ вызов — модуль импортируется один раз, а окно меняется в рантайме.
 */
export const isMiniAppShell = (windowWidth = typeof window !== "undefined"
    ? window.innerWidth
    : 1024) => isTelegramMiniApp() ||
    isMaxMiniApp() ||
    isMobileDevice() ||
    windowWidth <= MINIAPP_SHELL_MAX_WIDTH;
